import React from 'react';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { FolderCard } from 'modules/components/layer20';


export type FolderListSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: FolderListSectionProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.projectId ?? '');
  return (
    <Box
      display='flex'
      flexDirection='row'
      flexWrap='wrap'
      gap='.75rem'
    >
      {data.map((node) => (
        <FolderCard.FC
          key={node.id}
          {...node}
        />
      ))}

    </Box>
  );
};

